export default __webpack_public_path__ + "static/bannerbox.tiwag-89c2297b62f8bddf544cbb51c58b654a.jpg";